import React, { useState, useEffect, useRef, useContext } from "react";
import "./Traderader.css";
import banner from "../../../../src/Images/New_Home/images/banner.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import optiondashboard from "../../../../src/Images/New_Home/images/Icons/Option-dashboard-pvgu7cwloy2alkbs05y9meqvxns3odapmf9jm9ozoc.png";
import builtoption from "../../../../src/Images/New_Home/images/Icons/Built-Option-pvgwqz89ulhg998s09o55sfceq72ya0tvwgcm7uj6k.png";
import livemarket from "../../../../src/Images/New_Home/images/Icons/live-market-chart-pvgxhdj3s3mcb0wev6fyommcza3649tgik08sypifw.png";
// import builtscreeners from "../../../../src/Images/New_Home/images/Icons/Built-Screeners-pvgxgo5gnknlljx9zdh1bb0wxvk9cg0pf2e4uhr53w.png";
import optionpay from "../../../../src/Images/New_Home/images/Icons/Option-Pay-Of-pvgxv6rq7gj0wqu57ndltn57840c85ngqx43oc890c.png";
import OptionChain from "../../../../src/Images/New_Home/images/Icons/Option-Chain-pvgxvtburhdwndxdjx4nhhg9hcx5cw50u0rr6zasv0.png";
import Optiondashboard from "../../../../src/Images/New_Home/images/Icons/Option-dashboard-pvgu7cwloy2alkbs05y9meqvxns3odapmf9jm9ozoc.png";
import BuiltOption from "../../../../src/Images/New_Home/images/Icons/Built-Option-pvgwqz89ulhg998s09o55sfceq72ya0tvwgcm7uj6k.png";
import livemarketchart from "../../../../src/Images/New_Home/images/Icons/live-market-chart-pvgxhdj3s3mcb0wev6fyommcza3649tgik08sypifw.png";

import BuiltScreeners from "../../../../src/Images/New_Home/images/Icons/Built-Screeners-pvgxgo5gnknlljx9zdh1bb0wxvk9cg0pf2e4uhr53w.png";
import OptionPayOf from "../../../../src/Images/New_Home/images/Icons/Option-Pay-Of-pvgxv6rq7gj0wqu57ndltn57840c85ngqx43oc890c.png";
import optionchain from "../../../../src/Images/New_Home/images/Icons/Option-Chain-pvgxvtburhdwndxdjx4nhhg9hcx5cw50u0rr6zasv0.png";
import Screenshotc from "../../../../src/Images/New_Home/images/Screenshotc.png";
import Screenshot from "../../../../src/Images/New_Home/images/Screenshot (349).png";
import Screenshot1 from "../../../../src/Images/New_Home/images/Screenshot (350).png";
import Group from "../../../../src/Images/New_Home/images/Group 10.png";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';

function Traderader() {
    window.scrollTo(0, 0)
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

            // console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);
    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://traderadar.moneysukh.com/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }

    const clickToggleLoginimg = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://traderadar.moneysukh.com/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
    const clickToggleLoginbutton = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://traderadar.moneysukh.com/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
    return (
        <>
            <main class="home-new-main">

                <section class="trade-one">
                    <div class="container">
                        <div class="row text-center">
                            <div class="col-lg-12">
                                <h2 class="prof">Trade Radar - Professional Platform <br></br> for
                                    <span class="trader"> Professional Trader </span>
                                </h2>
                                <p class="sell">Moneysukh Traderadar provides best stock scanner for Intraday and swing trading.
                                    <br></br>
                                    Get Auto Buy / Sell Signal based on Technical Analysis with <br></br>
                                    target and stop loss for all market conditions.
                                </p>

                                <div class="monitarbox ">
                                    <img src={banner} class="img-fluid" onClick={clickToggleLoginimg} alt="image" />
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                {/* <section class="trade-two">
                    <div class="container">
                        <div class="row gy-4">
                            <h2 class="section-heading center text-center">
                                Most Advanced System for Auto Buy/Sell Signals
                                & Pre Built Options Strategy Wizards
                            </h2>
                            <div class="col-lg-4 col-md-4">
                                <div class="back shadow">
                                    <div class="d-flex">
                                        <div class="img"><img src={optiondashboard} alt="image" /></div>
                                        <div class="textbox ms-2">
                                            <h4 class="tradese">Trade seamlessly</h4>
                                            <p class="tradp">We never want to limit or <br></br> hold you back, so we offer <br></br> multiple instruments for you <br></br> to choose from</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="back shadow">
                                    <div class="d-flex">
                                        <div class="img"><img src={builtoption} alt="image" /></div>
                                        <div class="textbox ms-2">
                                            <h4 class="tradese">Very easy to <br></br>
                                                understand & use</h4>
                                            <p class="tradp">Get the best possible returns with lowest losses
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="back shadow">
                                    <div class="d-flex">
                                        <div class="img"><img src={livemarket} alt="image" /></div>
                                        <div class="textbox ms-2">
                                            <h4 class="tradese">Developed by <br></br>
                                                Professional traders</h4>
                                            <p class="tradp">The main point is all the <br></br> trading systems are <br></br> programmed and developed <br></br> by professional traders</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="back shadow">
                                    <div class="d-flex">
                                        <div class="img"><img src="" alt="image" /></div>
                                        <div class="textbox ms-2">
                                            <h4 class="tradese">In-Built Screeners
                                            </h4>
                                            <p class="tradp">Access your pre built screener i.e bullish- bearish, breakout</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="back shadow">
                                    <div class="d-flex">
                                        <div class="img"><img src={optionpay} alt="image" /></div>
                                        <div class="textbox ms-2">
                                            <h4 class="tradese">Option Pay Off
                                            </h4>
                                            <p class="tradp">Easy to understand live <br></br> Pay Off charts for day <br></br> traders</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="back shadow">
                                    <div class="d-flex">
                                        <div class="img"><img src={OptionChain} alt="image" /></div>
                                        <div class="textbox ms-2">
                                            <h4 class="tradese">Option Chain</h4>
                                            <p class="tradp">Free option chain with real <br></br> time prices including <br></br> option greeks also.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}




                <section class="trade-two">
                    <div class="container">
                        <h2 class="section-heading center text-center mostad">
                            Most Advanced System for Auto Buy/Sell Signals
                            & Pre Built Options Strategy Wizards
                        </h2>
                        <div class="gridpar row gy-5">
                            <div class="back ">
                                <div class="flexone">
                                    <div class="img"><img class="iconimg"
                                        src={Optiondashboard}
                                        alt="image" /></div>
                                    <div class="textbox ">
                                        <h4 class="tradese">Trade seamlessly</h4>
                                        <p class="tradp">We never want to limit or hold you back, so we offer multiple
                                            instruments for you to choose from</p>
                                    </div>
                                </div>
                            </div>


                            <div class="back ">
                                <div class="flexone">
                                    <div class="img"><img class="iconimg"
                                        src={BuiltOption}
                                        alt="image" /></div>
                                    <div class="textbox ">
                                        <h4 class="tradese">Very easy to <br></br>
                                            understand & use</h4>
                                        <p class="tradp">Get the best possible returns with lowest losses
                                        </p>
                                    </div>
                                </div>
                            </div>


                            <div class="back devmidhight">
                                <div class="flexone">
                                    <div class="img"><img class="iconimg"
                                        src={livemarketchart}
                                        alt="image" /></div>
                                    <div class="textbox ">
                                        <h4 class="tradese ">Developed by <br></br>
                                            Professional traders</h4>
                                        <p class="tradp">The main point is all the trading systems are programmed and developed
                                            by professional traders</p>
                                    </div>
                                </div>
                            </div>


                            <div class="back ">
                                <div class="flexone">
                                    <div class="img"><img class="iconimg"
                                        src={BuiltScreeners}
                                        alt="image" /></div>
                                    <div class="textbox ">
                                        <h4 class="tradese">In-Built Screeners
                                        </h4>
                                        <p class="tradp">Access your pre built screener i.e bullish- bearish, breakout</p>
                                    </div>
                                </div>
                            </div>


                            <div class="back ">
                                <div class="flexone">
                                    <div class="img"><img class="iconimg"
                                        src={OptionPayOf}
                                        alt="image" /></div>
                                    <div class="textbox ">
                                        <h4 class="tradese">Option Pay Off
                                        </h4>
                                        <p class="tradp">Easy to understand live Pay Off charts for day <br></br> traders</p>
                                    </div>
                                </div>
                            </div>


                            <div class="back">
                                <div class="flexone">
                                    <div class="img"><img class="iconimg"
                                        src={optionchain}
                                        alt="image" /></div>
                                    <div class="textbox ">
                                        <h4 class="tradese">Option Chain</h4>
                                        <p class="tradp">Free option chain with real time prices including option greeks also.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <section class="trade-three">
                    <div class="container">
                        <h2 class="section-heading-trade center text-center">
                            Reasons to Choose <br></br>
                            <span class="trader">Traderadar</span>
                        </h2>

                        <div class="pare">
                            <div class="childboxone">
                                <img src={Screenshotc} class="img-fluid desktopv" alt="image" />
                            </div>
                            <div class="childboxtwo shadow-lg">
                                <div class="halfss">

                                </div>
                                <div class="halfs">
                                    <img src={Screenshotc} class="img-fluid  phonevi   firstimg" alt="image" />
                                    <div className="textpadone">
                                        <h4>Market Pulse</h4>
                                        <p class="stay">Stay current with market movement and trade in stocks after filtering
                                            through various
                                            technical indicators.</p>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Dynamic heatmap</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Fresh longs / shorts</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Live advance / decline chart</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> 52 week high / low stocks with
                                            delivery details</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Realtime covering and unwinding in
                                            stocks</h6>
                                        <button className="learnbtn" onClick={() => clickToggleLoginbutton(true)}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pare mt-4">
                            <div class="childboxmidwhite shadow-lg middleboxx">

                                <img src={Screenshot} class="img-fluid posleft desktopv midnonn" alt="image" />

                                <div class="halfs leftsp">
                                    <img src={Screenshot} class="img-fluid posleft phonevi leftmid   " alt="image" />
                                    <div className="textpadmid">
                                        <h4 >Option Strategies</h4>
                                        <p class="stay">Just choose the trend and trade the strategy through the ready-made option
                                            strategy builder.</p>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Weekly / Monthly option Dashboard
                                        </h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Get all scenario option strategies
                                        </h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Payoff details with interactive
                                            chart</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> 52 week high / low stocks with
                                            delivery details</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Instant execution from the
                                            platform</h6>
                                        <button className="learnbtn midbtnbot" onClick={() => clickToggleLoginbutton(true)}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                    </div>
                                </div>
                                <div class="halfss">

                                </div>
                            </div>
                            <div class="childboxmid">
                                <img src={Screenshot} class="img-fluid posleft midimgg" alt="image" />
                            </div>
                        </div>
                        <div class="pare mt-4">
                            <div class="childboxone">
                                <img src={Screenshot1} class="img-fluid desktopv " alt="image" />
                            </div>
                            <div class="childboxtwo shadow-lg">
                                <div class="halfss">

                                </div>
                                <div class="halfs">
                                    <img src={Screenshot1} class="img-fluid phonevi " alt="image" />
                                    <div className="textpadone">
                                        <h4>Technical pattern
                                        </h4>
                                        <p class="stay">Stock scanner filters the markets through millions of data points to find
                                            stocks that meet a specific set of criteria.</p>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Candlestick screener</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Intraday stock pattern</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Intra Day Divergence Screener</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> EOD dashboard</h6>

                                        <button className="learnbtn" onClick={() => clickToggleLoginbutton(true)}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </section>


                <section class="trade-four">
                    <div class="container">
                        <h2 class="section-heading  center text-center str">How to Start</h2>
                        <div class="row justify-content-center">
                            <div class="col-lg-12">
                                <div class="d-flex justify-content-center ">
                                    <div class="flexone justify-content-start ">
                                        <div class="round ">1</div>
                                        <div>
                                            <p class="roundtext">Open your trading account with Moneysukh.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center ">
                                    <div class="flextwo justify-content-around">
                                        <div class="roundtwo ">2</div>
                                        <div>
                                            <p class="roundtext">After activating your account, visit <br></br> <span
                                                class="wwt">www.traderadar.moneysukh.com.</span> </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center ">
                                    <div class="flexone justify-content-start">
                                        <div class="roundthree ">
                                            <p>3</p>
                                        </div>
                                        <div>
                                            <p class="roundtext">Login on the platform using your Moneysukh trading <br></br> a/c
                                                credentials.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <section class="phoneround">
                    <div class="container">
                        <h2 class="section-heading center  text-center howto">How to Start</h2>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="d-flex justify-content-center">
                                    {/* <div class="mobround"><p>1</p></div> */}
                                    <p class="roundtext">Open your trading account with Moneysukh.</p>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center">
                                {/* <div><p>2</p></div>                            <div> */}
                                <div>
                                    <p class="roundtext">After activating your account, visit <span class="wwtrad">
                                        www.traderadar.moneysukh.com.</span></p>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center">
                                {/* <div><p>1</p></div> */}
                                <div>
                                    <p class="roundtext">Login on the platform using your Moneysukh trading a/c credentials.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>



                <section class="open-account-scc">
                    <div class="container">
                        <div class="head">Congratulations!</div>
                        <div class="img-container">
                            <img src={Group} class="img-fluid" alt="image" />
                        </div>
                        <div class="text-center now">
                            Now, you can trade & <br></br>
                            execute your orders
                        </div>
                        <button class="bttn" onClick={() => clickToggleLoginPopup(true)}>
                            Get started
                        </button>
                    </div>
                </section>
                <LoginPopup show={show} ref={childRef} />
            </main >
        </>
    );
}
export default Traderader;
